import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/main/shared/shared.module';

import { FlowForecastComponent } from './flow-forecast.component';
import { DataService } from './utils/service/data.service';
import { FlowForecastSVGService } from './utils/service/flow-forecast-svg.service';
import { FlowForecastUtilsService } from './utils/service/flow-forecast-utils.service';
import { MapService } from './utils/service/map.service';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [FlowForecastComponent],
  exports: [FlowForecastComponent],
  providers: [DataService, MapService, FlowForecastSVGService, FlowForecastUtilsService]
})
export class FlowForecastModule { }
